import { useEffect, useRef } from 'react';

/**
 * Pass in a callback function to fire it at regular intervals
 * @param callback Callback that is fired every `interval` milliseconds
 * @param interval Number of milliseconds to wait between callback invokes
 */
export function usePolling(
  callback: () => void | Promise<void>,
  interval: number = 120_000
) {
  const savedCallback = useRef(callback);

  // Update the ref if callback changes
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    let isMounted = true;
    let id: NodeJS.Timeout;

    const tick = async () => {
      if (!isMounted) return;
      await savedCallback.current();
      id = setTimeout(tick, interval);
    };

    tick(); // Start immediately

    return () => {
      isMounted = false;
      clearTimeout(id);
    };
  }, [interval]);
}
